<template>
  <div>
    <div class="head-nav d-aligncnter">
      <div class="nav-left d-allcenter" @click="backLastPage">
        <img src="@/assets/img/appointment/close-small.svg" />
      </div>
      <div class="nav-title d-allcenter overflow">人脸录入</div>
      <div class="nav-right"></div>
    </div>
    <div class="content">
      <div class="tips">1)自拍照需包含完整的面部,场馆进出需人脸识别</div>
      <div class="d-allcenter">
        <img src="@/assets/img/appointment/photo.svg" style="width: 300px" />
      </div>
      <div class="tips">2)点击下方按钮拍照存档</div>
      <div class="d-allcenter">
        <el-upload
          class="avatar-uploader"
          action="http://10.66.22.52:8081/app/tyapi/pc/venueOrder/upload"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          :accept="'image/*'"
          :data="{ userId: userId }"
        >
          <button class="d-allcenter takeimg"><img src="@/assets/img/appointment/camera.svg" /></button>
        </el-upload>
      </div>
    </div>
  </div>
</template>
<script>
import { Message } from 'element-ui'
export default {
  data() {
    return {
      userId: '',
      pageLoading: '',
    }
  },
  mounted() {
    this.userId = localStorage.getItem('userId')
  },
  methods: {
    backLastPage() {
      this.$router.go(-1)
    },
    handleAvatarSuccess(res, file) {
      console.log('handleAvatarSuccess:', res, file)
      this.pageLoading.close()
      //   this.imageUrl = URL.createObjectURL(file.raw)
      if (res.statusCode == 1) {
        Message.success('上传成功')
        this.backLastPage()
      } else {
        Message.error(res.message)
      }
    },
    beforeAvatarUpload(file) {
      console.log('beforeAvatarUpload:', file)
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        console.log('上传头像图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        console.log('上传头像图片大小不能超过 2MB!')
      }
      this.pageLoading = this.$loading({
        lock: true,
        text: '上传中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      setTimeout(() => {
        this.pageLoading.close()
      }, 10000)
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/appoint.scss';

.mt-16 {
  margin-top: 16px;
}

.head-nav {
  background: #181818;
}
.content {
  height: calc(100vh - 74px);
  overflow: auto;
  background: #181818;
  padding-bottom: 16px;
}
.tips {
  color: #fff;
  margin: 8px 0;
  font-size: 14px;
}
.takeimg {
  width: 300px;
  height: 56px;
  border-radius: 8px;
  background: #339571;
  border: #339571;
}
</style>
